import React from 'react'

function FranchiseOne() {
    return (
        <div className='container' >
            <div className="section_heading">
                <h1>Kalpataru <span> Franchise </span> Plans</h1>
            </div>
            <div className='row' >
                <div className='col' >

                </div>
            </div>
        </div>
    )
}

export default FranchiseOne